import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss']
})
export class WarningPopupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WarningPopupComponent>
  ) {}

  closeDialog(result: boolean) {
    if (this.isExitFlow()) {
      this.dialogRef.close(result);
    } else {
      this.dialogRef.close({ delete: result });
    }
  }

  isExitFlow(): boolean {
    const title = this.data?.title || '';
    const message = this.data?.message || '';
    const type = this.data?.type || '';
    return title.toLowerCase().includes('exit') || 
           message.toLowerCase().includes('exit') ||
           type.toLowerCase().includes('exit');
  }

  isDeleteFlow(): boolean {
    const title = this.data?.title || '';
    const message = this.data?.message || '';
    const type = this.data?.type || '';
    
    // If it explicitly includes exit, it is not a delete flow
    if (this.isExitFlow()) {
      return false;
    }
    
    return title.toLowerCase().includes('delete') || 
           message.toLowerCase().includes('delete') ||
           type.toLowerCase().includes('delete') ||
           type === 'LIST_ITEM' ||
           type === 'BUTTON' ||
           type === 'SOCIAL_LINK' ||
           (!title && !message && !type); // fallback for null data/empty delete warnings
  }

  getDisplayTitle(): string {
    if (this.isExitFlow()) {
      return 'Exit?';
    }
    if (this.isDeleteFlow()) {
      return 'Delete?';
    }
    return this.data?.title || 'Confirm?';
  }

  getDisplayMessage(): string {
    if (this.isExitFlow()) {
      return 'Any unsaved changes will be discarded. This cannot be undone.';
    }
    if (this.isDeleteFlow()) {
      return 'Are you sure you want to delete this item? This action cannot be undone.';
    }
    return this.data?.message || 'Are you sure you want to proceed?';
  }

  getConfirmButtonText(): string {
    if (this.isExitFlow()) {
      return 'Yes, Exit';
    }
    if (this.isDeleteFlow()) {
      return 'Yes, Delete';
    }
    return 'Confirm';
  }
}
